var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HistoryActions } from 'app/stores/history/actions';
import { projectSlice } from 'app/stores/project';
import { getSelectedMarkers, getSizeFactor } from 'app/stores/selectors';
import { updatePinOnSizeChange, updateTextOnFormatChange, updateTextOnSizeChange, } from 'app/utils/markers';
export const setProperty = createAsyncThunk('project/setProperty', (change, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const state = getState();
    const selectedMarkers = getSelectedMarkers(state).filter(marker => marker.alias !== 'Highlight');
    let action;
    let patches;
    const undoable = (_a = change.undoable) !== null && _a !== void 0 ? _a : true;
    switch (change.property) {
        case 'color': {
            if (selectedMarkers.length) {
                patches = selectedMarkers.reduce((accum, marker) => {
                    accum[marker.id] = { color: change.value };
                    return accum;
                }, {});
            }
            action = projectSlice.actions.setColor({
                color: change.value,
                undoable,
            });
            break;
        }
        case 'size': {
            if (selectedMarkers.length) {
                const sizeFactor = getSizeFactor(state);
                const scaledSize = change.value / sizeFactor;
                patches = selectedMarkers.reduce((accum, marker) => {
                    switch (marker.alias) {
                        case 'Pin':
                            accum[marker.id] = updatePinOnSizeChange(marker, change.value, sizeFactor);
                            break;
                        case 'Text':
                            accum[marker.id] = updateTextOnSizeChange(marker, change.value, sizeFactor);
                            break;
                        default:
                            accum[marker.id] = { size: scaledSize };
                            break;
                    }
                    return accum;
                }, {});
            }
            action = projectSlice.actions.setSize({
                size: change.value,
                undoable,
            });
            break;
        }
        case 'format': {
            if (selectedMarkers.length) {
                const formatPatch = change.value;
                patches = selectedMarkers.reduce((accum, marker) => {
                    switch (marker.alias) {
                        case 'Label':
                        case 'Text':
                            accum[marker.id] = updateTextOnFormatChange(marker, formatPatch);
                            break;
                        default:
                            break;
                    }
                    return accum;
                }, {});
            }
            // set global font family
            // action = ProjectActions.setSize({
            //     size: change.value,
            //     undoable,
            // });
            break;
        }
        default:
            break;
    }
    if (action) {
        dispatch(action);
    }
    // dispatch some side effect patches
    if (patches && Object.keys(patches).length > 0) {
        dispatch(HistoryActions.lock());
        dispatch(projectSlice.actions.itemsUpdate({ patches, undoable }));
        dispatch(HistoryActions.unlock());
    }
}));
